import { useMemo } from "react";
import {useConfigContext} from "../../../ConfigProvider.tsx";
import { useEnrichedProducts } from "../../../hooks/useEnrichedProducts.ts";
import { useAutocomplete } from "../../providers/AutocompleteProvider.tsx";
import { Panel } from "../Panel/Panel";
import { Product } from "../Product/Product";
import { ShowAllButton } from "../ShowAllButton/ShowAllButton";

export function Products() {
	const {
		autocompleteState: { collections, query, status },
		autocomplete,
	} = useAutocomplete();
	const { tc } = useConfigContext();
	const source  =  collections.find(({ source }) => source.sourceId === "products");
	const items = useMemo(() => {
		const productCollections = collections.filter(({ source }) => source.sourceId === "products");
		return productCollections[0]?.items || [];
	}, [collections]);
	const enrichedItems = useEnrichedProducts(items);

	if (!query) return;
	// "stalled" is still a pending search — with the debounced sources it is the
	// state the autocomplete sits in while waiting, so it must not show NoEntries.
	const isSearching = status === "loading" || status === "stalled";
	if (enrichedItems.length === 0 && !isSearching) return <NoEntries />;

	return (
		<Panel title={tc.products}>
			<div className="resultHeadline"><span>{tc.results_in_items} ({enrichedItems.length})</span><ShowAllButton /></div>

			<ul className="aa-Source algoliaAutocompleteProducts" {...autocomplete.getListProps()}>
				{enrichedItems.map((item, index) => (
					<Product key={item.objectID} hit={item} postFixLink={encodeURIComponent(query)} position={index}
							 /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
					// @ts-expect-error
					 source={source} />
				))}
			</ul>
		</Panel>
	);
}

function NoEntries() {
	const {
		autocompleteState: { query },
	} = useAutocomplete();
	const { tc } = useConfigContext();
	return (
		<div className="emptybox">
			{tc.noEntriesFoundForSearch} <q>{query}</q>.
		</div>
	);
}
